import { Controller } from "@hotwired/stimulus"

export default class ApplicationCheatPreventionController extends Controller {
  static targets = ["textarea"];

  connect() {
    this.handlePaste = this.handlePaste.bind(this);
    this.handleWindowBlur = this.handleWindowBlur.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);

    document.addEventListener("paste", this.handlePaste);
    window.addEventListener("blur", this.handleWindowBlur);
    document.addEventListener("contextmenu", this.handleContextMenu);
  }

  disconnect() {
    document.removeEventListener("paste", this.handlePaste);
    window.removeEventListener("blur", this.handleWindowBlur);
    document.removeEventListener("contextmenu", this.handleContextMenu);
  }

  handlePaste(event) {
    const targetTextarea = event.target.closest("textarea");

    if (targetTextarea && this.element.contains(targetTextarea)) {
      event.preventDefault();
      document.activeElement.blur();
      const eventType = event.ctrlKey || event.metaKey ? "pasteWithCtrl" : "pasteWithoutCtrl";
      this.sendRequest('paste', this.element.getAttribute('data-assessor-testing'));
    }
  }

  handleWindowBlur() {
    this.sendRequest("focus_lost", this.element.getAttribute('data-assessor-testing'));
  }

  handleContextMenu(event) {
    event.preventDefault();
  }

  sendRequest(eventType, testingId) {
    $.ajax({
      url: `/application/test/${testingId}/event`,
      type: "POST",
      dataType: "script",
      data: { event: eventType }
    });
  }
}
